import { IonIcon } from '@ionic/react';
import { appsOutline, arrowForwardOutline, calendarOutline, cashOutline, chevronForwardOutline, clipboardOutline, desktopOutline, flagOutline, logoWhatsapp, receiptOutline, refreshOutline, tabletPortraitOutline, trendingUpOutline, warningOutline } from 'ionicons/icons';
import React from 'react';
import { ResumoDia, temAcesso } from './resumoDia';

type Props = {
  nome: string;
  acessos: Record<string, unknown>;
  bloqueado: boolean;
  mesas: string;
  pedidos: string;
  onNavigate: (rota: string) => void;
  avisoPagamento?: string;
  onPagamento: () => void;
  mostrarResumo: boolean;
  resumo?: ResumoDia;
  carregando: boolean;
  erro: boolean;
  dia: string;
  onAtualizar: () => void;
  onboarding?: React.ReactNode;
};

export default function InicioPainel(props: Props) {
  const hora = new Date().getHours();
  const saudacao = hora < 12 ? 'Bom dia' : hora < 18 ? 'Boa tarde' : 'Boa noite';
  const primeiroNome = props.nome.trim().split(/\s+/)[0];
  const cards = [
    { acesso: 'vendas', titulo: 'Vendas', descricao: 'Funil de vendas e orçamentos', icon: trendingUpOutline, rota: './vendas' },
    { acesso: 'balcao', titulo: 'Balcão', descricao: 'Iniciar venda', icon: desktopOutline, rota: './caixa' },
    { acesso: 'comandas', titulo: props.mesas, descricao: 'Gerenciar atendimento', icon: clipboardOutline, rota: './comandas' },
    { acesso: 'projetos', titulo: props.pedidos, descricao: `Crie e acompanhe ${props.pedidos.toLocaleLowerCase('pt-BR')}`, icon: appsOutline, rota: './ordens' },
    { acesso: 'totem', titulo: 'Totem', descricao: 'Autoatendimento', icon: tabletPortraitOutline, rota: './totem' },
    { acesso: 'agenda', titulo: 'Agenda', descricao: 'Agende entregas, serviços e reuniões', icon: calendarOutline, rota: './agendamentoseventoscommenu' },
    { acesso: 'operacoes', titulo: 'Operações', descricao: 'Acompanhe o dia a dia da equipe', icon: flagOutline, rota: './operacoes' },
  ].filter(card => temAcesso(props.acessos[card.acesso]));
  const dinheiro = (valor: number) => valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const indicadores = [
    { titulo: 'Pedidos', icon: receiptOutline, cor: 'is-orange', valor: props.resumo?.pedidos.toLocaleString('pt-BR') },
    { titulo: 'Faturamento', icon: cashOutline, cor: 'is-green', valor: props.resumo && dinheiro(props.resumo.faturamento) },
    { titulo: 'Ticket médio', icon: trendingUpOutline, cor: 'is-purple', valor: props.resumo && dinheiro(props.resumo.ticketMedio) },
  ];

  return <>
    <header className="inicio-boas-vindas">
      <h1>{saudacao}{primeiroNome ? `, ${primeiroNome}` : ''}</h1>
      <p>Veja o que acontece na sua loja hoje.</p>
    </header>
    {props.avisoPagamento && <button type="button" className={`inicio-licenca ${props.bloqueado ? 'is-blocked' : ''}`} onClick={props.onPagamento}>
      <span className="inicio-licenca-icon"><IonIcon color="danger" icon={warningOutline} aria-hidden="true" /></span>
      <span className="inicio-licenca-texto">{props.avisoPagamento}</span>
      <span className="inicio-licenca-action">Ver pagamento<IonIcon color="danger" icon={arrowForwardOutline} aria-hidden="true" /></span>
    </button>}
    {props.onboarding}
    {cards.length > 0 && <section aria-labelledby="inicio-acessos-titulo">
      <h2 id="inicio-acessos-titulo" className="inicio-section-title">Acesso rápido</h2>
      <div className="inicio-acessos-grid">
        {cards.map(card => <button key={card.acesso} type="button" className="inicio-acesso-card" disabled={props.bloqueado} onClick={() => props.onNavigate(card.rota)}>
          <span className="inicio-card-icon"><IonIcon icon={card.icon} aria-hidden="true" /></span>
          <span className="inicio-acesso-texto"><strong>{card.titulo}</strong><span>{card.descricao}</span></span>
          <IonIcon className="inicio-chevron" icon={chevronForwardOutline} aria-hidden="true" />
        </button>)}
      </div>
    </section>}
    {props.mostrarResumo && <section className="inicio-resumo" aria-labelledby="inicio-resumo-titulo" aria-busy={props.carregando}>
      <div className="inicio-section-header">
        <div><h2 id="inicio-resumo-titulo" className="inicio-section-title">Resumo de hoje</h2><p>Vendas de hoje já encerradas · {props.dia.split('-').reverse().join('/')}</p></div>
        {props.erro && <button className="inicio-atualizar" type="button" aria-label="Atualizar resumo do dia" disabled={props.carregando} onClick={props.onAtualizar}><IonIcon icon={refreshOutline} aria-hidden="true" /><span>{props.carregando ? 'Atualizando' : 'Atualizar'}</span></button>}
      </div>
      <div className="inicio-resumo-grid" aria-live="polite">
        {indicadores.map(indicador => <article className="inicio-resumo-card" key={indicador.titulo}>
          <span className={`inicio-card-icon ${indicador.cor}`}><IonIcon icon={indicador.icon} aria-hidden="true" /></span>
          <div><h3>{indicador.titulo}</h3><p>{props.carregando ? <span className="inicio-skeleton" aria-label="Carregando" /> : indicador.valor ?? '—'}</p></div>
        </article>)}
      </div>
      {props.erro && <p className="inicio-resumo-erro" role="alert">Não foi possível carregar o resumo. Toque em Atualizar para tentar novamente.</p>}
    </section>}
  </>;
}

export function InicioSuporte() {
  return <div slot="fixed" className="inicio-suporte"><a href="https://api.whatsapp.com/send?phone=5511963927646" target="_blank" rel="noreferrer"><IonIcon icon={logoWhatsapp} aria-hidden="true" />Falar com suporte</a></div>;
}
